
import { computed, ref, Ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { Client } from 'altru-types';
import { RouteNames } from '@/router';
import { useRouter } from 'vue-router';

export default {
  name: 'TermsAndConditions',
  setup(): {
    workspaceTermsAcceptedAt: Ref<string | null>;
    toggleAcceptTerms: () => void;
    goToTermsView: () => void;
    t: (key: string) => string;
    termsCheckbox: Ref<HTMLInputElement | null>;
    clickWrapFeatureEnabled: Ref<boolean>;
  } {
    const termsCheckbox = ref<HTMLInputElement | null>(null);
    const { t } = useI18n();
    const { getters, dispatch } = useStore();
    const { push } = useRouter();
    const workspaceTermsAcceptedAt: Ref<string | null> = computed(() => getters['clients/workspaceTermsAcceptedAt']);

    const toggleAcceptTerms = () => {
      dispatch(
        'clients/toggleWorkspaceTermsAccepted',
        workspaceTermsAcceptedAt.value ? null : new Date().toISOString(),
      );
    };

    const goToTermsView = () => {
      push({
        name: RouteNames.Terms,
      });
    };

    const client: Ref<Client | null> = computed(() => getters['clients/workspaceInfo']);
    const clickWrapFeatureEnabled: Ref<boolean> = computed(
      () => client.value?.feature_keys?.includes('click_wrap_terms_and_conditions') ?? false,
    );

    return {
      workspaceTermsAcceptedAt,
      toggleAcceptTerms,
      goToTermsView,
      t,
      termsCheckbox,
      clickWrapFeatureEnabled,
    };
  },
};
